import { render } from "./roster_template.vue?vue&type=template&id=57992abf&scoped=true"
import script from "./roster_template.vue?vue&type=script&lang=js"
export * from "./roster_template.vue?vue&type=script&lang=js"

import "./roster_template.vue?vue&type=style&index=0&id=57992abf&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57992abf"]])

export default __exports__